export default "__VITE_ASSET__f85300f7__"